export default function Go_Functions_Recursion () {
  return (
    <div>
      <h1>Go_Functions_Recursion </h1>
      <p>Recursion</p>
    </div>
  );
}